import { cx } from '@linaria/core';
import { useRef } from 'react';
import { usePageContext } from '../../../../../context.js';
import { DropzoneContent } from '../../atom.dropzone-content/molecule.content.js';
import { content, wrapper } from './_dropzone.style.js';
import { DropzoneTarget } from './atom.target.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Dropzone(props) {
  const ref = useRef(null);
  const pageContext = usePageContext();
  return /*#__PURE__*/jsx("div", {
    className: cx(wrapper, props.className),
    ref: props.dropzoneRef,
    children: /*#__PURE__*/jsxs("div", {
      ref: ref,
      className: content,
      "data-theme": props.theme,
      "data-page-context": pageContext,
      children: [/*#__PURE__*/jsx(DropzoneContent, {
        ...props,
        allowMultipleTiles: true,
        wrapperRef: ref
      }), /*#__PURE__*/jsx(DropzoneTarget, {
        ...props
      })]
    })
  });
}

export { Dropzone };
//# sourceMappingURL=_dropzone.js.map
